import sendingEmail from "@/service/email";
import NotifyingEmail from "@/service/notification_file_service";
import { ReserveArticle } from "@/types/reserveArticle";

export async function sendMailAction(cart: ReserveArticle) {
  // console.log("WANT TO SEND MAIL BRO...");
  // console.log("::: POST ", cart, " EMAIL :::: ");

  try {
    const res = await sendingEmail(cart);

    console.log(" 🔥🔥🔥 RES FROM ACTION SEDING MAIL----- ", res);
    // const data = res?.json();
    // console.log(" 🔥🔥🔥 DATA SENT MAIL RES----- ", data);
    // console.log("DATA FROM ACTION ----- ", res.data.data);
    // if (!res?.data.data) {
    //   return console.log("Went wrong, didn't send mail.. : :::: : ", res.data);
    // }
    return res;
  } catch (error) {
    console.log("Error ACTION seding mail: :::: : ", error);
  }
}

export async function notifyEmail(title: string) {
  try {
    const res = await NotifyingEmail(title);

    console.log(" 🔥🔥🔥 RES FROM ACTION NOTIFYING MAIL----- ", res);

    return res;
  } catch (error) {
    console.log("Error ACTION seding mail: :::: : ", error);
  }
}
